exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".cust-sticky[data-v-4e9a0450]{position:-webkit-sticky!important;position:sticky!important;top:75px!important;z-index:99}.header[data-v-4e9a0450]{position:relative;overflow:hidden;height:2.6rem;line-height:2.6rem;text-align:center;background-color:#fff;border-radius:.25rem}.header .header-back[data-v-4e9a0450]{left:0}.header .header-act[data-v-4e9a0450],.header .header-back[data-v-4e9a0450]{position:absolute;top:0;width:2.6rem;font-size:1.2rem;text-align:center}.header .header-act[data-v-4e9a0450]{right:0}", ""]);

// exports
